import { createActions } from '../utils/actions';

const { actions: edit } = createActions('edit')
  .add('addPlaceholdersForNewListings')
  .add('cancelEdit')
  .add('createNew')
  .add('getData')
  .addAsync('getLinkedProducts')
  .add('getProduct')
  .addAsync('getProductData')
  .addAsync('getProfileListings')
  .add('removeNew')
  .add('saveAs')
  .addAsync('saveAsProfile')
  .addAsync('saveNew')
  .addAsync('saveToChannels')
  .add('setData')
  .addAsync('setListingsProfile')
  .add('setModal')
  .add('setProduct')
  .addAsync('setProfile')
  .add('toggleShop')
  .add('waitForOperations');

export default edit;
